const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0089 0 0 0.0089 8.4744 8.4744)",
    id: 160003
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-896, -896)",
    d: "M 1664 1632 v -1088 q 0 -13 -9.5 -22.5 t -22.5 -9.5 h -1088 q -13 0 -22.5 9.5 t -9.5 22.5 v 1088 q 0 13 9.5 22.5 t 22.5 9.5 h 1088 q 13 0 22.5 -9.5 t 9.5 -22.5 z m 128 -1088 v 1088 q 0 66 -47 113 t -113 47 h -1088 q -66 0 -113 -47 t -47 -113 v -1088 q 0 -66 47 -113 t 113 -47 h 1088 q 66 0 113 47 t 47 113 z m -384 -384 v 160 h -128 v -160 q 0 -13 -9.5 -22.5 t -22.5 -9.5 h -1088 q -13 0 -22.5 9.5 t -9.5 22.5 v 1088 q 0 13 9.5 22.5 t 22.5 9.5 h 160 v 128 h -160 q -66 0 -113 -47 t -47 -113 v -1088 q 0 -66 47 -113 t 113 -47 h 1088 q 66 0 113 47 t 47 113 z",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.ce23e8994ca683caac839f369ac37778.svg";
export { ForwardRef as ReactComponent };